/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { Reminder } from '@shared/models/reminder';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReminderService extends ApiClient {
  constructor(private httpClient: HttpClient, private datePipe: DatePipe) {
    super();
  }

  getMyReminders(startDate: Date, endDate: Date, active: boolean = true): Observable<Reminder[]> {
    const params: any = {
      active,
      'dateTime[after]': this.datePipe.transform(startDate, 'yyyy-MM-dd'),
      'dateTime[before]': this.datePipe.transform(endDate, 'yyyy-MM-dd')
    };

    return this.httpClient.get<Reminder[]>(`${environment.backendServer}/api/reminders/mine`, {
      headers: this.LD_JSON_HEADERS,
      params
    }).pipe(
      map(response => response['hydra:member'])
    );
  }

  updateReminder(reminder: Partial<Reminder>): Observable<Reminder> {
    return this.httpClient.put<Reminder>(`${environment.backendServer}/api/reminders/${this.extractId(reminder['@id'])}`, reminder, {
      headers: this.LD_JSON_HEADERS,
      observe: 'response'
    }).pipe(
      map(response => response.body)
    );
  }
}
